import { SMART_BOOKING_URL } from '@/src/constants/endpoints';
import { State } from '@/src/types/State';
import { useAccountContext } from '@ovotech/ui-tools';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Container,
  ImageMask,
  StyledLink,
  StyledCard,
  StyledHeading,
  StyledImage,
  StyledStack,
} from './SmartMeterBookingCard.styled';

const BANNER_URL =
  'https://www.ovobyus.com/transform/ea21d013-908e-49dc-83e1-69a0deacf164/DAY_03_INCIDENTALS_0017_RT?io=transform:fill,height:500,width:500&focuspoint=0.6,0.44';

export const SmartMeterBookingCard = () => {
  const { accountId } = useAccountContext();
  const smartMeterBookingRoute = `${SMART_BOOKING_URL}?accountId=${accountId}&utm_source=anytimeEligibility&utm_medium=MyOVO&utm_campaign=smart-meter-booking`;

  const smartMeterBooking = useSelector(
    (state: State) => state.smartMeterBooking,
  );

  const smartEligible = smartMeterBooking.showBanner;
  const hasSmartMeterBooking = smartMeterBooking.data?.booking.hasBooking;
  const isEligibleForSmb = smartEligible && !hasSmartMeterBooking;

  if (!isEligibleForSmb) {
    return null;
  }

  return (
    <StyledCard>
      <Container>
        <StyledStack spaceBetween={8}>
          <StyledHeading>Save money with a smart meter</StyledHeading>
          <StyledLink href={smartMeterBookingRoute} iconRight="chevron-right">
            Book your appointment
          </StyledLink>
        </StyledStack>

        <ImageMask>
          <StyledImage alt="Smart meter banner" src={BANNER_URL} />
        </ImageMask>
      </Container>
    </StyledCard>
  );
};
